export default __webpack_public_path__ + "static/iphonex-engaging-2da4c2fb6e5700194e340e692d4105a6.png";